import React, { useEffect, useState } from "react";
import {
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Box,
  Flex,
  Button,
  useDisclosure,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  FormControl,
  FormLabel,
  Input,
  ModalFooter,
  Modal,
  Text,
  Image,
  Center,
  Stack,
  Spinner,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { addGiftDiary, getGiftDairy } from "../Redux/App/action";
import { IoIosAddCircle } from "react-icons/io";
const GiftDiaries = () => {
  const dispatch = useDispatch();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);
  const [guestName, setguestName] = useState("");
  const [guestMobileNumber, setguestMobileNumber] = useState(0);
  const [eventType, seteventType] = useState("");
  const [eventName, seteventName] = useState("");
  const [eventDetails, seteventDetails] = useState("");
  const [giftName, setgiftName] = useState("");
  const [giftAmt, setgiftAmt] = useState(0);
  const [giftType, setgiftType] = useState("");
  const [description, setdescription] = useState("");
  const [note, setnote] = useState("");
  const { giftedByMe, isLoading } = useSelector((store) => store.appReducer);
  useEffect(() => {
    dispatch(getGiftDairy);
  }, []);

  const handleSubmit = () => {
    const formData = new FormData();
    formData.append("guestName", guestName);
    formData.append("guestMobileNumber", guestMobileNumber);
    formData.append("eventType", eventType);
    formData.append("eventName", eventName);
    formData.append("eventDetails", eventDetails);
    formData.append("giftName", giftName);
    formData.append("giftAmt", giftAmt);
    formData.append("giftType", giftType);
    formData.append("description", description);
    formData.append("note", note);

    dispatch(addGiftDiary(formData));
    onClose();
  };
  const Loader = () => {
    return (
      <Box
        position="fixed"
        top="0"
        left="0"
        width="100%"
        height="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        background="rgba(0, 0, 0, 0.5)"
        zIndex="9999"
      >
        <Spinner size="xl" color="blue.500" thickness="4px" />
      </Box>
    );
  };
  if (isLoading) {
    return (
      <Box h={"80vh"}>
        <Loader />
      </Box>
    );
  }
  return (
    <>
      <Box>
        <Modal
          initialFocusRef={initialRef}
          finalFocusRef={finalRef}
          isOpen={isOpen}
          onClose={onClose}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Create your Gift Diaries</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>
              <Flex gap={5}>
                <FormControl w={"50%"}>
                  <FormLabel>Guest Name</FormLabel>
                  <Input
                    ref={initialRef}
                    placeholder="guestName"
                    name="guestName"
                    value={guestName}
                    onChange={(e) => {
                      const sanitizedValue = e.target.value.replace(
                        /[^a-zA-Z\s]/g,
                        "",
                      );
                      setguestName(sanitizedValue);
                    }}
                  />
                </FormControl>

                <FormControl w={"50%"}>
                  <FormLabel>Guest Mobile Number</FormLabel>
                  <Input
                    placeholder="Mobile Number"
                    type="number"
                    name="guestMobileNumber"
                    value={guestMobileNumber}
                    onChange={(e) => setguestMobileNumber(e.target.value)}
                  />
                </FormControl>
              </Flex>
              <Flex gap={5}>
                <FormControl w={"50%"}>
                  <FormLabel>Event Type</FormLabel>
                  <Input
                    placeholder="Event Type"
                    name="eventType"
                    value={eventType}
                    onChange={(e) => {
                      const sanitizedValue = e.target.value.replace(
                        /[^a-zA-Z\s]/g,
                        "",
                      );
                      seteventType(sanitizedValue);
                    }}
                  />
                </FormControl>

                <FormControl w={"50%"}>
                  <FormLabel>Event Name</FormLabel>
                  <Input
                    placeholder="Event Name"
                    type="text"
                    name="eventName"
                    value={eventName}
                    onChange={(e) => {
                      const sanitizedValue = e.target.value.replace(
                        /[^a-zA-Z\s]/g,
                        "",
                      );
                      seteventName(sanitizedValue);
                    }}
                  />
                </FormControl>
              </Flex>

              <Flex gap={5}>
                <FormControl w={"50%"}>
                  <FormLabel>Event Details</FormLabel>
                  <Input
                    placeholder="Event Details"
                    name="eventDetails"
                    value={eventDetails}
                    onChange={(e) => seteventDetails(e.target.value)}
                  />
                </FormControl>

                <FormControl w={"50%"}>
                  <FormLabel>Gift Name</FormLabel>
                  <Input
                    placeholder="Gift Name"
                    type="text"
                    name="giftName"
                    value={giftName}
                    onChange={(e) => {
                      const sanitizedValue = e.target.value.replace(
                        /[^a-zA-Z\s]/g,
                        "",
                      );
                      setgiftName(sanitizedValue);
                    }}
                  />
                </FormControl>
              </Flex>
              <Flex gap={5}>
                <FormControl w={"50%"}>
                  <FormLabel>Gift Amount</FormLabel>
                  <Input
                    placeholder="gift Amt"
                    name="giftAmt"
                    value={giftAmt}
                    type="number"
                    onChange={(e) => setgiftAmt(e.target.value)}
                  />
                </FormControl>

                <FormControl w={"50%"}>
                  <FormLabel>Gift Type</FormLabel>
                  <Input
                    placeholder="Gift Type"
                    type="text"
                    name="giftType"
                    value={giftType}
                    onChange={(e) => {
                      const sanitizedValue = e.target.value.replace(
                        /[^a-zA-Z\s]/g,
                        "",
                      );
                      setgiftType(sanitizedValue);
                    }}
                  />
                </FormControl>
              </Flex>
              <Flex gap={5}>
                <FormControl w={"50%"}>
                  <FormLabel>Description</FormLabel>
                  <Input
                    placeholder="Description"
                    name="description"
                    type="text"
                    value={description}
                    onChange={(e) => setdescription(e.target.value)}
                  />
                </FormControl>

                <FormControl w={"50%"}>
                  <FormLabel>Note</FormLabel>
                  <Input
                    placeholder="Note"
                    type="text"
                    name="note"
                    value={note}
                    onChange={(e) => setnote(e.target.value)}
                  />
                </FormControl>
              </Flex>
            </ModalBody>

            <ModalFooter>
              <Button colorScheme="blue" mr={3} onClick={handleSubmit}>
                Add Gift Diary
              </Button>
              <Button onClick={onClose}>Cancel</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Box>
      <Tabs p={2}>
        <TabList mb="1em">
          <Tab w={"50%"} borderRadius={14}>
            <Flex
              alignItems={"center"}
              gap={{ md: 20, base: 1 }}
              justifyContent={"center"}
              fontWeight={"bold"}
              fontSize={18}
              color={"#200E32"}
            >
              GIFTED BY ME{" "}
              <IoIosAddCircle size={24} color="green" onClick={onOpen} />
            </Flex>
          </Tab>
          <Tab w={"50%"} borderRadius={14}>
            <Flex
              alignItems={"center"}
              gap={{ md: 20, base: 2 }}
              justifyContent={"center"}
              fontWeight={"bold"}
              fontSize={18}
            >
              RECEIVED{" "}
            </Flex>
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel textAlign={"left"}>
            <Box
              display={"grid"}
              gridTemplateColumns={{
                md: "repeat(4,1fr)",
                base: "repeat(1,1fr)",
              }}
              gap={4}
            >
              {giftedByMe &&
                giftedByMe.map((el, i) => (
                  <Center py={5} key={i}>
                    <Box
                      role={"group"}
                      p={6}
                      maxW={"330px"}
                      w={"full"}
                      boxShadow={"2xl"}
                      rounded={"lg"}
                      pos={"relative"}
                      zIndex={1}
                    >
                      <Box
                        rounded={"lg"}
                        mt={-12}
                        pos={"relative"}
                        height={"230px"}
                        _after={{
                          transition: "all .3s ease",
                          content: '""',
                          w: "full",
                          h: "full",
                          pos: "absolute",
                          top: 5,
                          left: 0,
                          backgroundImage: `url(${""})`,
                          filter: "blur(15px)",
                          zIndex: -1,
                        }}
                        _groupHover={{
                          _after: {
                            filter: "blur(20px)",
                          },
                        }}
                      >
                        <Image
                          rounded={"lg"}
                          height={230}
                          width={282}
                          objectFit={"cover"}
                          src={el.optionalImg}
                          alt="#"
                        />
                      </Box>
                      <Stack pt={10} align={"center"}>
                        <Text
                          color={"gray.500"}
                          fontSize={"sm"}
                          textTransform={"uppercase"}
                        >
                          Guest Name:{" "}
                          <span style={{ color: "black" }}>{el.guestName}</span>
                        </Text>
                        <Text
                          color={"gray.500"}
                          fontSize={"sm"}
                          textTransform={"uppercase"}
                        >
                          Event Name:{" "}
                          <span style={{ color: "black" }}>{el.eventName}</span>
                        </Text>
                        <Text
                          color={"gray.500"}
                          fontSize={"sm"}
                          textTransform={"uppercase"}
                        >
                          Event Type:{" "}
                          <span style={{ color: "black" }}>{el.eventType}</span>
                        </Text>

                        <Text
                          color={"gray.500"}
                          fontSize={"sm"}
                          textTransform={"uppercase"}
                        >
                          Amount:{" "}
                          <span style={{ color: "black" }}>{el.giftAmt}</span>
                        </Text>
                      </Stack>
                    </Box>
                  </Center>
                ))}
            </Box>
          </TabPanel>
          <TabPanel textAlign={"left"}>
            <Box
              display={"grid"}
              gridTemplateColumns={{
                md: "repeat(4,1fr)",
                base: "repeat(1,1fr)",
              }}
              gap={4}
            >
              {giftedByMe &&
                giftedByMe.map((el, i) => (
                  <Center py={5} key={i}>
                    <Box
                      role={"group"}
                      p={6}
                      maxW={"330px"}
                      w={"full"}
                      boxShadow={"2xl"}
                      rounded={"lg"}
                      pos={"relative"}
                      zIndex={1}
                    >
                      <Box
                        rounded={"lg"}
                        mt={-12}
                        pos={"relative"}
                        height={"230px"}
                        _after={{
                          transition: "all .3s ease",
                          content: '""',
                          w: "full",
                          h: "full",
                          pos: "absolute",
                          top: 5,
                          left: 0,
                          backgroundImage: `url(${""})`,
                          filter: "blur(15px)",
                          zIndex: -1,
                        }}
                        _groupHover={{
                          _after: {
                            filter: "blur(20px)",
                          },
                        }}
                      >
                        <Image
                          rounded={"lg"}
                          height={230}
                          width={282}
                          objectFit={"cover"}
                          src={
                            "https://images.immediate.co.uk/production/volatile/sites/30/2020/01/retro-cocktails-b12b00d.jpg"
                          }
                          alt="#"
                        />
                      </Box>
                      <Stack pt={10} align={"center"}>
                        <Text
                          color={"gray.500"}
                          fontSize={"sm"}
                          textTransform={"uppercase"}
                        >
                          Guest Name:{" "}
                          <span style={{ color: "black" }}>{el.guestName}</span>
                        </Text>
                        <Text
                          color={"gray.500"}
                          fontSize={"sm"}
                          textTransform={"uppercase"}
                        >
                          Event Name:{" "}
                          <span style={{ color: "black" }}>{el.eventName}</span>
                        </Text>
                        <Text
                          color={"gray.500"}
                          fontSize={"sm"}
                          textTransform={"uppercase"}
                        >
                          Event Type:{" "}
                          <span style={{ color: "black" }}>{el.eventType}</span>
                        </Text>

                        <Text
                          color={"gray.500"}
                          fontSize={"sm"}
                          textTransform={"uppercase"}
                        >
                          Amount:{" "}
                          <span style={{ color: "black" }}>{el.giftAmt}</span>
                        </Text>
                      </Stack>
                    </Box>
                  </Center>
                ))}
            </Box>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </>
  );
};

export default GiftDiaries;
